var map = {
	"./120/2g-sim.svg": 213,
	"./120/3g-sim.svg": 214,
	"./120/4g-sim.svg": 215,
	"./120/account-manager.svg": 216,
	"./120/app-advisor.svg": 217,
	"./120/bus-tickets.svg": 218,
	"./120/calls.svg": 219,
	"./120/chef.svg": 220,
	"./120/connections.svg": 221,
	"./120/dashboard.svg": 222,
	"./120/data-connectivity.svg": 223,
	"./120/dnd-activate.svg": 224,
	"./120/dnd-desactivate.svg": 225,
	"./120/ensuring-uninterrupted-services-business.svg": 226,
	"./120/find-rates.svg": 227,
	"./120/get-help.svg": 228,
	"./120/international-roaming.svg": 229,
	"./120/internet.svg": 230,
	"./120/iplc.svg": 231,
	"./120/isd-advanced.svg": 232,
	"./120/isd.svg": 233,
	"./120/itfs.svg": 234,
	"./120/maintenance.svg": 235,
	"./120/messages.svg": 236,
	"./120/network-issues.svg": 237,
	"./120/one-more-product.svg": 238,
	"./120/online-shopping.svg": 239,
	"./120/organization.svg": 240,
	"./120/page-not-found.svg": 241,
	"./120/pay-outstanding-invoices.svg": 242,
	"./120/payment-allocated.svg": 243,
	"./120/payment-trends.svg": 244,
	"./120/payment-uncompleted.svg": 245,
	"./120/pharmacy.svg": 246,
	"./120/savings.svg": 247,
	"./120/search-files.svg": 248,
	"./120/second-tv.svg": 249,
	"./120/smart-savings.svg": 250,
	"./120/smartphone-action.svg": 251,
	"./120/thought-leadership-article-on-ddos.svg": 252,
	"./120/upload-tds.svg": 253,
	"./120/whats-next.svg": 254,
	"./120/write.svg": 255,
	"./180/2g-sim.svg": 256,
	"./180/3g-sim.svg": 257,
	"./180/4g-sim.svg": 258,
	"./180/account-manager.svg": 259,
	"./180/calls.svg": 260,
	"./180/connections.svg": 261,
	"./180/dashboard.svg": 262,
	"./180/data-connectivity.svg": 263,
	"./180/discount-tickets.svg": 264,
	"./180/dnd-activate.svg": 265,
	"./180/dnd-desactivate.svg": 266,
	"./180/ensuring-uninterrupted-services-business.svg": 267,
	"./180/find-rates.svg": 268,
	"./180/get-help.svg": 269,
	"./180/international-roaming.svg": 270,
	"./180/internet.svg": 271,
	"./180/iplc.svg": 272,
	"./180/isd-advanced.svg": 273,
	"./180/isd.svg": 274,
	"./180/itfs.svg": 275,
	"./180/maintenance.svg": 276,
	"./180/messages.svg": 277,
	"./180/network-issues.svg": 278,
	"./180/one-more-product.svg": 279,
	"./180/organization.svg": 280,
	"./180/pay-outstanding-invoices.svg": 281,
	"./180/payment-allocated.svg": 282,
	"./180/payment-trends.svg": 283,
	"./180/payment-uncompleted.svg": 284,
	"./180/search-files.svg": 285,
	"./180/thought-leadership-article-on-ddos.svg": 286,
	"./180/upload-tds.svg": 287,
	"./180/whats-next.svg": 288,
	"./240/2g-sim.svg": 289,
	"./240/3g-sim.svg": 290,
	"./240/4g-sim.svg": 291,
	"./240/calls.svg": 292,
	"./240/connections.svg": 293,
	"./240/data-connectivity.svg": 294,
	"./240/discount-tickets.svg": 295,
	"./240/dnd-activate.svg": 296,
	"./240/dnd-desactivate.svg": 297,
	"./240/ensuring-uninterrupted-services-business.svg": 298,
	"./240/find-rates.svg": 299,
	"./240/international-roaming.svg": 300,
	"./240/internet.svg": 301,
	"./240/iplc.svg": 302,
	"./240/isd-advanced.svg": 303,
	"./240/isd.svg": 304,
	"./240/itfs.svg": 305,
	"./240/maintenance.svg": 306,
	"./240/messages.svg": 307,
	"./240/network-issues.svg": 308,
	"./240/one-more-product.svg": 309,
	"./240/organization.svg": 310,
	"./240/pay-outstanding-invoices.svg": 311,
	"./240/payment-allocated.svg": 312,
	"./240/payment-trends.svg": 313,
	"./240/payment-uncompleted.svg": 314,
	"./240/savings.svg": 315,
	"./240/search-files.svg": 316,
	"./240/secure-browsing.svg": 317,
	"./240/thought-leadership-article-on-ddos.svg": 318,
	"./240/upload-tds.svg": 319,
	"./240/whats-next.svg": 320,
	"./240/write.svg": 321,
	"./40/africa.svg": 322,
	"./40/all-regions.svg": 323,
	"./40/asia.svg": 324,
	"./40/europe.svg": 325,
	"./40/north-america.svg": 326,
	"./40/oceania.svg": 327,
	"./40/south-america.svg": 328,
	"./60/africa.svg": 329,
	"./60/all-regions.svg": 330,
	"./60/asia.svg": 331,
	"./60/europe.svg": 332,
	"./60/north-america.svg": 333,
	"./60/oceania.svg": 334,
	"./60/south-america.svg": 335,
	"./other/error-404-280.svg": 336,
	"./other/error-404-320.svg": 337,
	"./other/office-in-a-box.svg": 338
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/svgs/illustrations ^\.\/.*\.svg$
// module id = 764
// module chunks = 0